<template>
  <div>
      <b-card 
        title="AppVersions"
      >
        <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            variant="primary"
            :to="{ name: 'app-version-add'}"
            class="mr-1"
          >
            Create AppVersion
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="3"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <label
            class="mr-1"
          >
              Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block mr-1"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>

    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
        <b-table 
          responsive
          :sort-by.sync="sortBy" 
          :sort-desc.sync="sortDesc" 
          :items="items" 
          :fields="fields" 
          :no-local-sorting="true" 
          @sort-changed="sortingChanged"
          :busy="isBusy"
          class="w-100"
        >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
                <strong class="text-secondary">Loading...</strong>
              </div>
            </template>
            <template #cell(action)="data">
                <div class="d-flex justify-content-start">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="secondary"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.top="'Edit AppVersion'"
                    @click="$router.push({name: 'app-version-edit', params: { key: data.item.id}})"
                  >
                    <feather-icon icon="Edit3Icon" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    class="btn-icon mr-1"
                    v-b-tooltip.hover.top="'Delete AppVersion'"
                    @click="showMsgBoxDelete(data.item)"
                    v-if="isApprover"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </div>
            </template>
            <template #cell(PROD_CATEGORY)="data">
              {{ data.item.product_category_details && data.item.product_category_details.name ? data.item.product_category_details.name : '-' }}
            </template>
            <template #cell(cfu)="data">
              {{ data.item.cfu_details && data.item.cfu_details.length > 0 ? data.item.cfu_details.map(x => x.cfu_name).join(',') : '-'}}
            </template>
            <template #cell(publish)="data">
              <div>
                <b-form-checkbox v-if="data.item.APPROVED_BY"
                  :checked="data.item.PROD_SHOW_STATUS == 1 ? 'true':'false'"
                  class="custom-control-danger"
                  name="check-button"
                  @change="approval(data.item.KODE)"
                  switch
                />
                <b-form-checkbox
                  v-else
                  :disabled="data.item.APPROVED_BY == NULL"
                  :checked="data.item.PROD_SHOW_STATUS == 1 ? 'true':'false'"
                  class="custom-control-danger"
                  name="check-button"
                  @change="approval(data.item.KODE)"
                  switch
                  style="cursor:auto !important"
                  v-b-tooltip.hover.top="'Need Approve First'"
                />
              </div>
            </template>
            <template #cell(CREATED_DATE)="data">
              <div>{{ $moment(data.value).format("YYYY-MM-DD  ") }}</div>
            </template>
            <template #cell(PROD_SHOW_STATUS)="data">
              <b-badge pill v-if="!data.item.archived_at && data.value == 1" variant="success">
                {{ data.item.archived_at ? 'Archived' : data.value == 1 ? 'Publish' : 'Unpublish'}} 
              </b-badge>
              <b-badge pill v-if="data.item.archived_at || data.value == 0" >
                {{ data.item.archived_at ? 'Archived' : data.value == 1 ? 'Publish' : 'Unpublish'}} 
              </b-badge>
              <b-badge pill variant="warning" v-if="data.item.RETIREMENT == 1">
                {{ data.item.RETIREMENT == 1 ? 'Retired' : '' }}
              </b-badge>
            </template>
        </b-table>
    </div>

    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <div v-if="!isBusy && items.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && items.length > 0"
        v-for="(item, index) in items"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.version }}</strong>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top="'Edit AppVersion'"
              @click="$router.push({name: 'app-version-edit', params: { key: item.id}})"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon mr-1"
              v-b-tooltip.hover.top="'Delete AppVersion'"
              @click="showMsgBoxDelete(item)"
              v-if="isApprover"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>NOTES: </strong>{{ item.notes || '-' }}</p>
            <p><strong>CREATED AT: </strong>{{ $moment(item.created_at).format("YYYY-MM-DD  ") }}</p>
            <p><strong>UPDATED AT: </strong>{{ $moment(item.updated_at).format("YYYY-MM-DD  ") }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ currentPage * perPage - perPage + 1 }} to {{ currentPage * perPage - perPage + showData  }} of {{ totalData }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="inputPagination"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
      <b-modal
        id="image-review"
        scrollable
        title="Image Review"
        ok-title="Close"
        centered
        cancel-variant="outline-secondary"
        :ok-only="true"
        size="md"
      >
          <b-card-text
          >
              <b-row class="justify-content-center">
                  <b-col md="8" sm="4">
                      <b-img
                        thumbnail
                        fluid
                        rounded
                        :src="imgSelectedItem"
                      >

                      </b-img>
                  </b-col>
              </b-row>
          </b-card-text>
      </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BSpinner, BFormCheckbox, BModal, BImg, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
  },
  data() {
    return {
      xlsData: [],
      perPage: '10',
      perPageOptions: ['10', '20', '30'],
      productStatus: '',
      productStatusOpt: ['publish','unpublish','archived','retired'],
      currentPage: 1,
      totalData: 200,
      showData: 0,
      items: [],
      sortBy: 'updated_at',
      sortDesc: true,
      searchWord: '',
      isBusy: false,

      selectedItem: {
        icon: '',
        icon_details: {}
      }
    }
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  computed: {
    skip() {
      return this.perPage * (this.currentPage - 1)
    },
    imgSelectedItem() {
      return typeof this.selectedItem.icon_details === 'object' && typeof this.selectedItem.icon_details.original === 'object' ? this.selectedItem.icon_details.original.url : ''
    },
    isApprover() {
      let permissions = this.$store.getters['oauth/getActiveUser'].permissions
      if (!permissions.includes('approve_product')) {
        return false
      }
      return true
    },
    fields() {
      return [
        { key: 'version', label: 'Version', sortable: true },
        { key: 'notes', label: 'Notes', sortable: false },
        { key: 'created_at', label: 'Created At', sortable: true },
        { key: 'updated_at', label: 'Updated At', sortable: true },
        { key: 'action', label: 'Action' },
      ]
    }
  },
  watch: {
    perPage() {
      this.getAppVersion()
    },
    currentPage() {
      this.getAppVersion()
    },
    searchWord() {
      this.$store.dispatch('app/search', {
        callback: () => {
          this.getAppVersion()
        }
      })
    },
    productStatus(){
      this.getAppVersion()
    }
  },
  mounted() {
    this.getAppVersion()
  },
  methods: {
    async getAppVersion() {
      let searchWord  = this.searchWord.trim()
      let base = '/app-version/browse/with.total/true'
      let take = `/take/${this.perPage}`
      let skip = `/skip/${this.skip}`
      let search = `${searchWord !== '' ? `/s/${searchWord}`: ''}`
      let orderBy = `/orderBy.${this.sortBy}/${this.sortDesc === true ? 'desc' : 'asc'}`
      let complete = base + take + skip + search + orderBy
      this.isBusy = true
      const mapRequest = {
          map: {
              id: 'i',
              version: 's',
              notes: 'd',
              created_at: 'd',
              updated_at: 'd'
          }
      }
      return await this.$http.post(complete, mapRequest)
      .then( res => {
        this.items = res.data.data.records
        this.totalData = res.data.data.total
        this.showData = res.data.data.show
      })
      .catch( err => {
        console.error(err)
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    async deleteAppVersion(item) {
      this.isBusy = true
      return await this.$http.delete(`/app-version/${item.id}`)
      .then(res => {
        this.$notif('Success', 'AppVersion has been successfully deleted.', 'success')
      })
      .catch(err => {
        let message = ''
        if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
        } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
        }
        this.$notif('Something Error', message , 'danger')
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    inputPagination(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc}) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.getAppVersion()
      }
    },
    showMsgBoxDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          value === true && this.deleteAppVersion(item).then(() => this.getAppVersion())
        })
    },

    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      if(this.xlsData.length == 0){
        this.$notif('Please wait', 'Still getting all product data' , 'danger')
      }else{
        import('@/libs/Export2Excel').then(excel => {
            const list = records
            const data = formatJson(fieldVal, list)
            excel.export_json_to_excel({
              header: headers,
              data,
              filename,
              autoWidth: true,
              bookType: 'xlsx'
            })
        })
      }
    },

    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'kode') {
          data = v.KODE
        }

        if (j === 'product') {
          data = v.PRODUCT
        }
        
        if (j === 'category') {
          data = v.product_category_details ? v.product_category_details.name : ''
        }

        if (j === 'cfu') {
          data = v.cfu_details.length > 0 ? v.cfu_details.map(cfu => cfu.cfu_name).toString() : ''
        }

        if (j === 'status') {
          console.log(v.archived_at !== null || v.PROD_SHOW_STATUS == 0)
          let a = ''
          let b = ''
          let c = ''
          if(v.archived_at == null && v.PROD_SHOW_STATUS == 1){
            a = v.archived_at !== null ? ' Archived' : v.PROD_SHOW_STATUS == 1 ? ' Publish' : ' Unpublish'
          }
          if(v.archived_at !== null || v.PROD_SHOW_STATUS == 0 || v.PROD_SHOW_STATUS == null){
            b = v.archived_at !== null ? ' Archived' : v.PROD_SHOW_STATUS == 1 ? ' Publish' : ' Unpublish'
          }
          if(v.RETIREMENT == 1){
            c = v.RETIREMENT == 1 ? ' Retired' : ''
          }
          data = a+b+c
        }

        if (j === 'date') {
          data = v.CREATED_DATE
        }

        return data
      }))
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>